import { render, staticRenderFns } from "./TasksBoard.vue?vue&type=template&id=3603753c&scoped=true&"
import script from "./TasksBoard.vue?vue&type=script&lang=js&"
export * from "./TasksBoard.vue?vue&type=script&lang=js&"
import style0 from "./TasksBoard.vue?vue&type=style&index=0&id=3603753c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603753c",
  null
  
)

export default component.exports